import * as React from 'react';

function FreeBetSb(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
      <g clipPath="url(#prefix__clip0_5417_5667)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.682 4.216a1.436 1.436 0 002.038 0l2.147 2.163L6.332 18l-2.147-2.163a1.462 1.462 0 000-2.053 1.436 1.436 0 00-2.038 0L0 11.621 11.535 0l2.147 2.163a1.462 1.462 0 000 2.053zm-5.089 6.83c.41.413 1.076.413 1.487 0 .613-.624.67-1.813.675-2.316 0-.953-.01-1.555-.01-1.555s-.598-.01-1.544-.01c-.499 0-1.679.057-2.298.68a1.064 1.064 0 000 1.498c.27.272.65.361.993.278.032 0 .063.005.089.031.041.037.047.1.01.131-.25.194-.92.618-1.596.309l1.45 1.461c-.306-.68.115-1.356.307-1.608.031-.036.094-.026.13.01a.1.1 0 01.031.09 1.05 1.05 0 00.276 1zm.561-2.677l.822-.42-.421.828.655.655-.915-.142-.416.828-.146-.917-.915-.146.827-.424-.146-.917.655.655z"
          fill="#007AB8"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_5417_5667">
          <path fill="white" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default FreeBetSb;
